import React from 'react';

class TermFilter extends React.Component {
    constructor(props) {
        super(props);

        this.state =  {
            showAll: false,
            filterOpen: false,
        };

        this.onTermChange = this.onTermChange.bind(this);
        this.onShowToggle = this.onShowToggle.bind(this);
        this.onMenuToggle = this.onMenuToggle.bind(this);
        this.onFilterMenuToggle = this.onFilterMenuToggle.bind(this);
    }

    componentDidUpdate() {
        if (this.props.pagetype == 'category') {
            if (!this.categoryIsVisible() && !this.state.showAll && this.props.categorySlug != 'kategorier') {
                this.setState(() => ({
                    showAll: !this.categoryIsVisible(),
                }));
            }
        }
    }

    categoryIsVisible() {
        const firstCategories = this.props.categories.slice(0, 10);
        return firstCategories.some(cat => cat.slug === this.props.categorySlug);
    }

    onTermChange(event) {
        window.location = event.target.value;
    }

    onShowToggle() {
        this.setState(() => ({
            showAll: !this.state.showAll,
        }));
    }

    onMenuToggle(event) {
        const menuItem = event.currentTarget.parentElement;
        menuItem.classList.toggle('open');
    }

    onFilterMenuToggle(e) {
        e.preventDefault();

        this.setState(() => ({
            filterOpen: !this.state.filterOpen,
        }));
    }

    render() {
        const archiveIndex = window.archive?.index || [];

        const currentCategory = this.props.categories.filter((c) => c.slug == this.props.categorySlug);
        const filterTermText = currentCategory[0]?.name ?? 'Alla kategorier';

        const monthNames = {
            1: 'Januari',
            2: 'Februari',
            3: 'Mars',
            4: 'April',
            5: 'Maj',
            6: 'Juni',
            7: 'Juli',
            8: 'Augusti',
            9: 'September',
            10: 'Oktober',
            11: 'November',
            12: 'December',
        };

        return (
            <React.Fragment>
                <div className="filter__ordering filter__ordering--desktop col-auto d-none d-lg-flex align-items-center pr-0">
                    <select className="form-control" onChange={this.props.onOrderingChange} value={this.props.ordering}>
                        <option value="DESC">Nyast först</option>
                        <option value="ASC">Äldsta först</option>
                    </select>
                </div>
                <div className="filter__mobile col-12 d-lg-none">
                    <div className="row">
                        <div className="filter__ordering col-auto d-flex pr-0">
                            <select className="form-control" onChange={this.props.onOrderingChange} value={this.props.ordering}>
                                <option value="DESC">Nyast först</option>
                                <option value="ASC">Äldsta först</option>
                            </select>
                            <span className='select-arrow'></span>
                        </div>
                        { this.props.pagetype == 'category' && 
                            <div className="filter__terms col-auto d-flex d-lg-none pl-0">
                                <a href="#" onClick={this.onFilterMenuToggle}>{filterTermText.charAt(0).toUpperCase() + filterTermText.slice(1)}</a>
                            </div>
                        }
                        { this.props.pagetype == 'archive' && 
                            <div className="filter__terms col-auto d-flex d-lg-none pl-0">
                                <a href="#" className={this.state.filterOpen ? 'open' : ''} onClick={this.onFilterMenuToggle}>{`${monthNames[parseInt(window.archive.month)]} ${window.archive.year}`}</a>
                            </div>
                        }
                    </div>
                </div>
                <div className="filter__wrapper col-12 col-lg-3">
                    <div className={`filter ${this.state.filterOpen ? 'filter--open' : ''} d-none d-lg-block`}>
                    <div className="filter__items">
                        { this.props.pagetype == 'category' && 
                            <React.Fragment>
                                <ul>
                                    <li key={-1}><a href={`/kategorier/`} className={this.props.categorySlug === 'kategorier' ? `active` : ''}>Alla</a></li>
                                    {this.props.categories.map((child, index) => {
                                        return <li key={index} style={!this.state.showAll && index > 9 ? {display: 'none'} : []}><a href={`/${child.slug}/`} className={this.props.categorySlug === child.slug ? `active` : ''}>{child.name.charAt(0).toUpperCase() + child.name.slice(1)}</a></li>;
                                    })}
                                </ul>
                                {this.props.categories.length > 9 &&
                                    <button className={`filter__button ${(this.state.showAll ? 'filter__button--less' : '')}`} onClick={this.onShowToggle}>
                                        { this.state.showAll ? 'Färre kategorier' : 'Fler kategorier' }
                                    </button>
                                }
                            </React.Fragment>
                        }
                        { this.props.pagetype == 'archive' && 
                            <React.Fragment>
                                <ul className='filter__menu'>
                                    {archiveIndex.map((year, index) => {
                                        return (
                                            <li key={index} className={year.year == window.archive.year ? 'open' : ''}>
                                                <span onClick={this.onMenuToggle}>{year.year}</span>
                                                <ul>
                                                    {year.months.map((month, childindex) => {
                                                        return <li key={childindex}><a href={`/${year.year}/${month.number}/`} className={year.year == window.archive.year && month.number == window.archive.month ? `active` : ''}>{month.name} <span>({month.total})</span></a></li>;
                                                    })}
                                                </ul>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </React.Fragment>
                        }
                    </div>
                    </div>
                </div>
                <div className={`filter__overlay ${this.state.filterOpen ? 'filter__overlay--show' : ''}`} onClick={this.onFilterMenuToggle}></div>
            </React.Fragment>
        );
    }
}

export default TermFilter;